<div class="ui-table {{expanded?'ui-table-expanded':''}}" [style.width]="expandedWidth">

	<div class="ui-table-toolbar row" *ngIf="!options?.noToolbar">
		<nav class="col-lg-6">
			<ul class="pagination justify-content-start">
				<li *ngFor="let p of chunker.pagination.pages" class="page-item {{p.active?'':'disabled'}} {{p.isCurrent?'active':''}}">
					<div class="page-link" (click)="goToPage(p.index)">
						<span [innerHTML]="p.name && p.active && p.name != '<<' && p.name != '>>' ? p.name : '&nbsp;'"></span>
						<i class="material-icons" *ngIf="p.name=='<<' || p.name=='>>'">{{p.name == '<<' ? 'first_page' : 'last_page'}}</i>
					</div>
				</li>
			</ul>
		</nav>

		<nav class="col-lg-6">
			<ul class="pagination justify-content-end ui-table-toolbar">

				<li class="page-link page-item with-btn helper-clickable" *ngIf="filters && hasFiltersOn()" (click)="removeFilters()" [title]="'clear filters'">
					<div class="btn ">
						<span class="material-icons" style="margin-left: 0px;"> filter_alt </span>
						<span class="material-icons color-red red" style="position: absolute;margin-left: -4px;margin-top: -4px;"> close </span>
					</div>
				</li>
				<li class="page-link page-item with-btn helper-clickable" *ngIf="options?.refreshButton" (click)="onRefresh()" [title]="'refresh'">
					<div class="btn ">
						<span class="material-icons">
							refresh
						</span>
					</div>
				</li>
				<li class="page-item">
					<div class="page-link page-link-results">{{chunker.pagination.fullResultsCount != chunker.pagination.total ? chunker.pagination.total + "/" : ''}}{{chunker.pagination.fullResultsCount ? chunker.pagination.fullResultsCount : 0}} result(s)</div>
				</li>
				<li class="page-item" *ngIf="options?.paginationCountSelector">
					<div class="page-link ui-table-toolbar-pagination-select">
						<ui-input-dropdown [metadata]="{options:{choices:{'10':10,'100':'100','1000':1000},noEmptyChoice:true}}" (ngModelChange)="onPaginationSizeChange($event)" [(ngModel)]="paginationSize"></ui-input-dropdown>
					</div>
				</li>
				<!--
				<li class="page-item" (click)="expand()">
				  <div class="page-link"><i class="material-icons">panorama_horizontal</i></div>
				</li>
				-->
				<li class="page-item helper-clickable" *ngIf="options?.downloadAsExcel" (click)="downloadAsExcel()" matTooltip="download as excel file">
					<div class="page-link helper-clickable"><i class="material-icons">get_app</i></div>
				</li>
			</ul>
		</nav>
	</div>

	<form><!-- mandatory to use the ngmodel -->
		<table class="table table-sm  mb-0">
			<thead>
			<tr *ngIf="headers">
				<th *ngFor="let h of headers" (click)="sortBy(h)" [class]="h.class+(h.sortable?' helper-clickable':'')" [style]="h.style">
					{{h.label}}
					<i class="material-icons ui-table-toolbar-sorter {{sorting && sorting.by && sorting.by.id == h.id ?sorting?.direction:''}}" *ngIf="h.sortable && (!sorting || sorting.by.id != h.id || !sorting.direction || (!sorting.direction||sorting.direction=='dsc'))">arrow_drop_down</i>
					<i class="material-icons ui-table-toolbar-sorter ui-table-toolbar-sorter-up {{sorting && sorting.by && sorting.by.id == h.id ?sorting?.direction:''}}" *ngIf="h.sortable && (!sorting || sorting.by.id != h.id || (sorting.by && sorting.by.id == h.id && (!sorting.direction||sorting.direction=='asc')))">arrow_drop_up</i>
				</th>
			</tr>
			<tr *ngIf="filters">
				<th *ngFor="let h of headers">
					<ui-input *ngIf="h.filterable" [(ngModel)]="h.filterValue" (ngModelChange)="applyFilters(h.id)" [name]="'th.filter.'+h.id" [metadata]="h"></ui-input>
				</th>
			</tr>
			</thead>
			<tbody>
			<ng-content></ng-content>
			</tbody>
		</table>
		<small style="display: block;text-align: center;width: 100%;background: #cccccc17;" *ngIf="chunkedSize===0 && !options?.noEmptyText">
			({{isFiltered ? 'no results with these filters' : 'table is empty'}})
		</small>
	</form>
</div>
